import {toggleButtonClasses} from '@mui/material';

/**
 * Material-UI overrides based on designs and pairing
 * We use the theme as a param to make the switch between dark and light easier
 * @param {*} theme - theme to be used as baseline
 */
export const componentOverrides = {
  MuiAlert: {
    defaultProps: {
      variant: 'outlined',
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        border: 'none',
        [`&.${toggleButtonClasses.disabled}`]: {
          border: 'none',
        },
      },
    },
  },
  MuiSlider: {
    styleOverrides: {
      markLabel: {
        top: 20,
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      avatar: ({theme}) => ({
        color: (theme.vars || theme).palette.action.active,
      }),
    },
  },
};
